
import sdModal from '@smartdesign/vue/components/modal';
import sdLink from '@smartdesign/vue/components/link';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AdvantagesSection',
  components: {
    sdModal,
    sdLink,
  },
  inject: ['isMobile'],
  data() {
    return {
      isModalVisible: false,
    };
  },
});
